/** @format */

import {Trans} from 'react-i18next';

import {Box} from '@mui/material';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';
import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';
import Modal from 'components/Modal';

import {
  ModalBody,
  ModalBodyText,
  ModalButtonsBox,
  ModalHeadingBox,
  ModalHeadingText,
} from './styles';

export interface DistributeModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const SensorDistributeModal = ({onClose, onConfirm}: DistributeModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeadingBox>
        <Box
          component='span'
          className='material-symbols-outlined'
          style={{
            fontSize: 22,
            color: '#141418',
            fontVariationSettings: "'FILL' 1",
          }}
        >
          tenancy
        </Box>
        <ModalHeadingText>
          <Trans>Распределить стандартно</Trans>
        </ModalHeadingText>
      </ModalHeadingBox>
      <ModalBody>
        <ModalBodyText>
          <Trans>Вы собираетесь заменить настройки критичности сенсоров на стандартные</Trans>
        </ModalBodyText>
        <ModalBodyText>
          <Trans>Текущие настройки будут удалены</Trans>
        </ModalBodyText>
      </ModalBody>
      <ModalButtonsBox>
        <PrimaryMediumButton onClick={onConfirm}>
          <Trans>Распределить</Trans>
        </PrimaryMediumButton>
        <SecondaryMediumButton onClick={onClose}>
          <Trans>Отмена</Trans>
        </SecondaryMediumButton>
      </ModalButtonsBox>
    </Modal>
  );
};

export {SensorDistributeModal};
